import { defineStore } from "pinia";
import { ref } from "vue";
import { useRouter } from "vue-router";
import appApi from "@/services/api/";
import { exceptionRequestMsg, showToast } from "@/assets/js/util";
import { useGeneralStore } from "@/store/general";
import { storeToRefs } from "pinia";
import useUtil from "@/composables/useUtil";

const storeGeneral = useGeneralStore();
const { loadingPage } = storeToRefs(storeGeneral);

const useContratosStore = defineStore("contratos", () => {
  const loadingClientes = ref(true);
  const contratosCompraVenta = ref([]);
  const contratosDomiciliacion = ref([]);
  const contratosGeneral = ref([]);
  const clientes = ref([]);
  const value = ref("");
  const loadingButton = ref(false);
  const {baseURL} = useUtil()

  const cliente = ref("");
  const descripcion = ref("");
  const periodo = ref("");
  const cuenta = ref("");
  const banco = ref("");
  const clabe = ref("");
  const monto_maximo = ref("");
  const vencimiento = ref("");
  const no_cliente = ref("");
  const no_contrato = ref("");

  const router = useRouter();

  const fetchClientes = async () => {
    try {
      const response = await appApi().get("clientes?all=true");
      clientes.value = response.data;
      loadingClientes.value = false;
    } catch (e) {
      exceptionRequestMsg(e);
    }
  };

  const fetchContratosDomiciliacion = async () => {
    storeGeneral.initLoadingPage();
    try {
      const response = await appApi().get("contratos/domiciliacion/");
      contratosDomiciliacion.value = response.data;

      loadingPage.value = false;
    } catch (e) {
      console.log(e);
      exceptionRequestMsg(e);
    }
  };

  const fetchContratosCompraVenta = async () => {
    storeGeneral.initLoadingPage();
    try {
      const response = await appApi().get("contratos/compra_venta/");
      contratosCompraVenta.value = response.data;

      loadingPage.value = false;
    } catch (e) {
      console.log(e);
      exceptionRequestMsg(e);
    }
  };

  const fetchContratosGeneral = async () => {
    console.log("Llegamos");
    storeGeneral.initLoadingPage();
    try {
      const respone = await appApi().get("contratos/general/");
      contratosGeneral.value = respone.data;

      loadingPage.value = false;
    } catch (e) {
      exceptionRequestMsg(e);
    }
  };

  const truncateString = (str, maxLength = 20) => {
    if (str.length > maxLength) {
      return str.slice(0, maxLength) + "...";
    }
    return str;
  };

  const storeContratoCompraVenta = async () => {
    const { id } = cliente.value;
    console.log("Cliente id", id);
    const form = document.getElementById("formContrato");
    const formData = new FormData(form);
    formData.append("cliente_id", id);

    try {
      const response = await appApi().post(
        "contratos/compra_venta/store",
        formData
      );

      console.log(response);

      const { status, message } = response.data;
      loadingButton.value = false;

      if (!status) {
        showToast(message, "error");
        return;
      }

      showToast(message, "success");
      router.push({
        name: "contrato-compra-venta",
      });
    } catch (e) {
      console.log(e);
      exceptionRequestMsg(e);
    }
  };

  const storeContratoDomiciliacion = async () => {
    loadingButton.value = true;
    const { id } = cliente.value;
    const form = document.getElementById("formContrato");
    const formData = new FormData(form);
    formData.append("cliente_id", id);

    try {
      const response = await appApi().post(
        "contratos/domiciliacion/store",
        formData
      );

      const { status, message } = response.data;
      loadingButton.value = false;

      if (!status) {
        showToast(message, "error");
        return;
      }

      showToast(message, "success");
      router.push({
        name: "contrato-domiciliacion",
      });
    } catch (e) {
      loadingButton.value = false;
      exceptionRequestMsg(e);
    }
  };

  const storeContratoGeneral = async () => {
    console.log(cliente.value);
    try {
      loadingButton.value = true;
      const { id } = cliente.value;
      const form = document.getElementById("formContrato");
      const formData = new FormData(form);
      formData.append("cliente_id", id);

      const response = await appApi().post("contratos/general/store", formData);

      const { status, message } = response.data;
      loadingButton.value = false;

      if (!status) {
        showToast(message, "error");
        return;
      }

      showToast(message, "success");
      router.push({
        name: "contrato-general",
      });
    } catch (e) {
      loadingButton.value = false;
      exceptionRequestMsg(e);
    }
  };

  const urlDownload = (contrato, contrato_url) => {
    return (
      baseURL.value +
      `contratos/${contrato_url}/${contrato}/download`
    );
  };

  return {
    contratosDomiciliacion,
    loadingClientes,
    clientes,
    value,
    cliente,
    descripcion,
    periodo,
    banco,
    cuenta,
    clabe,
    monto_maximo,
    vencimiento,
    no_cliente,
    no_contrato,
    loadingButton,
    loadingPage,
    contratosCompraVenta,
    contratosGeneral,

    truncateString,

    fetchContratosDomiciliacion,
    fetchContratosCompraVenta,
    fetchContratosGeneral,
    fetchClientes,
    storeContratoDomiciliacion,
    urlDownload,
    storeContratoCompraVenta,
    storeContratoGeneral,
  };
});

export default useContratosStore;
